import styled from 'styled-components';

export const Image = styled.img`
  border-radius: 50%;
`;
